var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.966 0.41214C5.369 0.41214 0 5.70393 0 12.2061C0 18.7082 5.369 24 11.966 24C18.563 24 23.9321 18.7082 23.9321 12.2061C23.9321 5.70393 18.563 0.41214 11.966 0.41214ZM11.966 23.0993C5.8545 23.0993 0.913873 18.2297 0.942432 12.2061C0.942432 6.18244 5.88306 1.31287 11.9946 1.34102C18.1061 1.34102 23.0467 6.21059 23.0182 12.2342C23.0182 13.7824 22.6755 15.3023 22.0472 16.6816C20.248 20.5941 16.3069 23.0993 11.966 23.0993Z",
    fill: "url(#paint0_linear_20_10492)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 5.81598H8.2819C6.76829 5.81598 5.54028 6.99833 5.51172 8.4622V15.9223C5.54028 17.4143 6.76829 18.5967 8.2819 18.5685H15.6214C17.135 18.5967 18.3631 17.3862 18.3916 15.9223V8.4622C18.3631 6.99833 17.135 5.81598 15.65 5.81598ZM17.2778 15.9504C17.2778 16.8231 16.5639 17.5269 15.6786 17.5269C15.65 17.5269 15.65 17.5269 15.6214 17.5269H8.2819C7.39658 17.5551 6.65406 16.8794 6.6255 16.0067C6.6255 15.9786 6.6255 15.9786 6.6255 15.9504V8.49035C6.6255 7.61766 7.33947 6.91388 8.22478 6.91388C8.25334 6.91388 8.25334 6.91388 8.2819 6.91388H15.6214C16.5068 6.88573 17.2493 7.56136 17.2778 8.43405C17.2778 8.4622 17.2778 8.4622 17.2778 8.49035V15.9504Z",
    fill: "url(#paint1_linear_20_10492)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9661 8.88409C10.1098 8.88409 8.59619 10.3763 8.59619 12.2063C8.59619 14.0363 10.1098 15.5285 11.9661 15.5285C13.8224 15.5285 15.336 14.0363 15.336 12.2063C15.336 10.3763 13.8224 8.88409 11.9661 8.88409ZM11.9661 14.4023C10.7095 14.4023 9.70997 13.4169 9.70997 12.1781C9.70997 10.9394 10.7095 9.95395 11.9661 9.95395C13.2227 9.95395 14.2222 10.9394 14.2222 12.1781V12.2063C14.2222 13.4169 13.2227 14.4305 11.9661 14.4305V14.4023Z",
    fill: "url(#paint2_linear_20_10492)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5645 9.53306C16.0062 9.53306 16.3642 9.17985 16.3642 8.74415C16.3642 8.30844 16.0062 7.95523 15.5645 7.95523C15.1229 7.95523 14.7649 8.30844 14.7649 8.74415C14.7649 9.17985 15.1229 9.53306 15.5645 9.53306Z",
    fill: "url(#paint3_linear_20_10492)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_10492",
    x1: 2.80099,
    y1: 22.4505,
    x2: 20.9544,
    y2: 1.57172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECAE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E0213F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9B358B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_10492",
    x1: 1.28591,
    y1: 24.1436,
    x2: 23.0762,
    y2: -0.908312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECAE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E0213F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9B358B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_10492",
    x1: 1.28509,
    y1: 24.144,
    x2: 23.078,
    y2: -0.908276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECAE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E0213F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9B358B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_10492",
    x1: 1.57005,
    y1: 24.3975,
    x2: 23.3738,
    y2: -0.657238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECAE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E0213F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9B358B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4A9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.abdfc50d9f0b0a01e1c0525200f14abb.svg";
export { ForwardRef as ReactComponent };